import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { DestroySpinner, HideSpinner, ProcessChange, ShowSpinner } from './spinner.classes';

export interface SpinnerStateModel {
  isLoading: boolean;
  progress: number;
}

@State<SpinnerStateModel>({
  name: 'spinner',
  defaults: {
    isLoading: false,
    progress: 0,
  },
})
@Injectable()
export class SpinnerState {
  count: number = 0;

  @Action(ShowSpinner)
  show(ctx: StateContext<SpinnerStateModel>) {
    this.count++;
    ctx.patchState({ isLoading: true });
  }

  @Action(HideSpinner)
  hide(ctx: StateContext<SpinnerStateModel>) {
    if (this.count > 0) this.count--;
    if (this.count <= 0) {
      ctx.patchState({ isLoading: false });
    }
  }

  @Action(DestroySpinner)
  destroy(ctx: StateContext<SpinnerStateModel>) {
    this.count = 0;
    ctx.patchState({ isLoading: false });
  }

  @Action(ProcessChange)
  changeProcess(ctx: StateContext<SpinnerStateModel>, { percent }: ProcessChange) {
    if (percent > 100) {
      ctx.patchState({ progress: 100 });
    } else if (percent < 0) {
      ctx.patchState({ progress: 0 });
    } else {
      let result = Math.round(percent * 100) / 100;
      ctx.patchState({ progress: Math.round(result) });
    }

  }
}
